import {
  AppstoreOutlined,
  FilterOutlined,
  SearchOutlined,
  UnorderedListOutlined,
  UserSwitchOutlined,
} from "@ant-design/icons";
import {
  Row,
  Col,
  Button,
  Input,
  List,
  Radio,
  Space,
  Tooltip,
  DatePicker,
  Layout,
  Typography,
  Card,
} from "antd";
import Search from "antd/es/input/Search";
import { useState } from "react";
import type { Dayjs } from "dayjs";

const { Content } = Layout;
const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

interface Props {
  onSearch: (value: string) => void;
  onSearchChangeValue?: (value: string) => void;
  onChangeViewLayout: (value: any) => void;
  onSearchPressEnter: (value: any) => void;
  onDateRangeSelect?: (value: any) => void;
}

const SearchAnnouncementsForm = (props: Props) => {
  const [searchText, setSearchText] = useState("");
  const [organizerSearchText, setOrganizerSearchText] = useState("");
  const [isListView, setIsListView] = useState(true);
  const [eventType, setEventType] = useState<
    "Presencial" | "Virtual" | "Mixto" | null
  >(null);
  const [selectedDateRange, setSelectedDateRange] = useState<Dayjs[] | null>(
    null
  );
  const [organizer, setOrganizer] = useState("");

  return (
    <>
      <Space direction="vertical" size={24} className="w-full">
        <Row gutter={16} align="middle">
          <Col>
            <RangePicker
              size="large"
              onChange={(dates) => {
                if (props.onDateRangeSelect) {
                  props.onDateRangeSelect(dates);
                }
              }}
            />
          </Col>
          <Col flex="auto">
            <Search
              addonBefore={<SearchOutlined />}
              className="ant-input-shadow"
              placeholder="Buscar por nombre de convocatoria"
              allowClear
              onChange={(event) => {
                if (props.onSearchChangeValue) {
                  props.onSearchChangeValue(event.target.value);
                }
              }}
              onPressEnter={($event: any) => {
                props.onSearchPressEnter($event.target.value);
              }}
              onSearch={(value: string) => {
                props.onSearch(value);
              }}
              style={{ borderRadius: 0 }}
              enterButton="Buscar"
              size="large"
            />
          </Col>

          <Col>
            <Space>
              <Button
                icon={
                  isListView ? <AppstoreOutlined /> : <UnorderedListOutlined />
                }
                onClick={() => {
                  setIsListView(!isListView);
                  props.onChangeViewLayout(!isListView);
                }}
              >
                {isListView ? "Grilla" : "Lista"}
              </Button>
            </Space>
          </Col>
        </Row>
      </Space>
    </>
  );
};

export default SearchAnnouncementsForm;
